import { Component, OnInit } from '@angular/core';

import { Subject, Observable, of } from 'rxjs';
import { cloneDeep } from 'lodash';
import { DynamicFormCommonConfig } from 'zr-dynamic-form/dynamic-form-common';

import { AbstractPropertyEditorBase } from '../../types/property-editor.types';
import { EntityAttributeDataModel } from '../..//types/control.types';
import { ControlModelPropertyEnum } from '../../types/control-model-property';
import { entityAttributeChange } from '../../utils/entity-attribute-helper';

@Component({
  selector: 'df-entity-property-editor',
  templateUrl: './entity-property-editor.component.html',
  styleUrls: ['./entity-property-editor.component.css']
})
export class EntityPropertyEditorComponent extends AbstractPropertyEditorBase<EntityAttributeDataModel[]>
  implements OnInit {
  multiProperty: { [x: string]: string };

  properties: EntityAttributeViewModel[]; // å½åå±æ§

  jsonKeySettings = {
    changeType: 'blur',
    hidden: true,
    maxlength: 200,
    reg: /^([\_A-Za-z\u4e00-\u9fa5]{1}[\_A-Za-z0-9\u4e00-\u9fa5]*){1}(\.{1}[\_A-Za-z\u4e00-\u9fa5]{1}[\_A-Za-z0-9\u4e00-\u9fa5]*)*$/,
    regErrorMsg: 'JSON KEYéæ»¡è¶³xx.xx.xxæ ¼å¼,ä¸æ¯æ®µåªè½ä»¥å­æ¯ä¸­ææè_å¼å¤´,ä¸è½æé¤äºæ°å­å­æ¯ä¸­æå_ä¹å¤çå¶ä»ç¹æ®å­ç¬¦'
  };

  constructor(private commonConfig: DynamicFormCommonConfig) {
    super();
  }

  ngOnInit() {}

  afterControlValueInit() {
    this.multiProperty = this.settings.multiProperty;
    if (!this.multiProperty) {
      this.multiProperty = { '': 'å±æ§' };
    }

    const attributeDataModels: EntityAttributeViewModel[] = [];

    for (const key in this.multiProperty) {
      if (this.multiProperty.hasOwnProperty(key)) {
        attributeDataModels.push({
          source: key,
          target: '',
          jsonKeySettings: cloneDeep(this.jsonKeySettings)
        });
      }
    }

    // å¦ævalueå¼æ¯ç©ºï¼åå1.3.6çæ¬ä»¥åè®¾å®çå¼,æ¥å¼å®¹
    if (!this.value) {
      this.value = [];
    }

    this.reBuildValue();

    this.properties = attributeDataModels.map((s) => {
      if (!this.value) {
        return s;
      }
      const model = this.value.find((m) => m.source === s.source);
      if (model) {
        s.target = model.target;
        s.jsonKey = model.jsonKey;
      }
      return s;
    });
  }

  /**
   * éæ°æå»ºvalue å¼å®¹åæ¥æ ¼å¼
   *
   */
  private reBuildValue() {
    // TODO æªæ¥çæ¬è¦ç§»é¤æ­¤å¼å®¹æ§ï¼å¨æ­¤ä¹åï¼éè¦æ§è¡¨åéæ°åå¸ä¸æ¬¡
    const entityAttributes = Object.keys(this.control.model).filter((s) => {
      return s.startsWith(ControlModelPropertyEnum.EntityAttribute);
    });
    entityAttributes.forEach((s) => {
      if (typeof s !== 'string') {
        return;
      }
      const propertyCode = s.substring(ControlModelPropertyEnum.EntityAttribute.length);
      // å¦ææ°å¼ä¸­ä¸å­å¨çï¼éè¦å¨åæ¥çå¼ä¸­åï¼ä»¥å¼å®¹åæ¥æ ¼å¼
      if (!this.value.find((attribute) => attribute.source === propertyCode)) {
        this.value.push({
          source: propertyCode,
          target: this.control.model[s]
        });
      }
    });
  }

  attributeValueChange(value: string, model: EntityAttributeViewModel) {
    entityAttributeChange.next({ dataEntity: this.settings.dataEntity, entityAttributes: this.settings.items });

    model.target = value;
    const item = this.settings.items.find((x: any) => x[this.settings.valueMember] === value);

    // è®¾ç½®jsonkeyå­æ®µæ¾ç¤º
    if (item !== undefined && item.dataType.toLowerCase() === 'json') {
      model.jsonKeySettings.hidden = false;
    } else {
      model.jsonKeySettings.hidden = true;
      // éèæ¶è¦æ¸ç©º
      model.jsonKey = undefined;
    }
    this.buildValue();
  }

  jsonKeyValueChange(val: string, model: EntityAttributeViewModel) {
    this.validateJsonKey(val).subscribe(
      (s) => {
        model.jsonKey = val;
        this.buildValue();
      },
      (error) => {
        // å¦æä¸å è¿ä¸ªï¼æ¢å¤å°åæ¥å¼ä¸çæ~~
        const tempVal = model.jsonKey;
        model.jsonKey = val;
        setTimeout(() => {
          model.jsonKey = tempVal;
        });
      }
    );
  }

  /**
   * æå»ºvalueå¼
   */
  private buildValue() {
    this.value = cloneDeep(this.properties).map((s) => {
      delete s.jsonKeySettings;
      return s;
    });
  }

  /**
   * jsonKeyå¼æ ¡éª
   */
  private validateJsonKey(data: string): Observable<string> {
    const sub = new Subject<string>();
    if (data && this.jsonKeySettings.reg) {
      const reg = this.jsonKeySettings.reg;
      if (!reg.test(data)) {
        this.commonConfig.log.error(this.jsonKeySettings.regErrorMsg || 'è¾å¥æ°æ®æ ¼å¼ä¸ç¬¦åè¦æ±');
        sub.error('');
        sub.complete();
        return sub;
      }
    }
    return of(data);
  }
}

/**
 *
 *
 */
export interface EntityAttributeViewModel extends EntityAttributeDataModel {
  jsonKeySettings: any;
}
